import type { CropDefinition, PlotPhase, PlotState } from '../../../core/domain/types';

export const MAX_OFFLINE_MS = 72 * 60 * 60 * 1000;

export function effectiveNow(lastSeenUtc: number, deviceNowUtc: number): number {
  const noRollback = Math.max(lastSeenUtc, deviceNowUtc);
  return Math.min(noRollback, lastSeenUtc + MAX_OFFLINE_MS);
}

export function getPlotPhase(
  plot: PlotState,
  crop: CropDefinition | undefined,
  nowUtc: number,
): PlotPhase {
  if (!plot.unlocked) return 'locked';
  if (!plot.cropId || plot.plantedAtUtc === null) return 'empty';
  if (!crop) return 'empty';
  return nowUtc >= plot.plantedAtUtc + crop.growSeconds * 1000 ? 'mature' : 'growing';
}

export function getGrowthProgress(
  plot: PlotState,
  crop: CropDefinition | undefined,
  nowUtc: number,
): number {
  if (!crop || plot.plantedAtUtc === null) return 0;
  return Math.min(1, Math.max(0, (nowUtc - plot.plantedAtUtc) / (crop.growSeconds * 1000)));
}

export function createPlots(count = 24, initiallyUnlocked = 6): PlotState[] {
  return Array.from({ length: count }, (_, index) => ({
    plotId: `plot_${String(index + 1).padStart(2, '0')}`,
    unlocked: index < initiallyUnlocked,
    cropId: null,
    plantedAtUtc: null,
    harvestCount: 0,
  }));
}
